import FieldText from './FieldText.vue';
import FieldFloat from './FieldFloat.vue';
import FieldSelect from './FieldSelect.vue';
import FieldPhone from './FieldPhone.vue';
import FieldInn from './FieldInn.vue';
import FieldSwitch from './FieldSwitch.vue';
import HtmlEditor from './HtmlEditor.vue';

export function registerFieldComponents(app) {
    // Регистрируем синхронно, чтобы в шаблонах не появлялись строковые представления промисов
    // вместо реальных инпутов (как это было на форме создания товара).
    app.component('FieldText', FieldText);
    app.component('FieldFloat', FieldFloat);
    app.component('FieldSelect', FieldSelect);
    app.component('FieldPhone', FieldPhone);
    app.component('FieldInn', FieldInn);
    app.component('FieldSwitch', FieldSwitch);
    app.component('HtmlEditor', HtmlEditor);
}
